import { Axios } from 'common/services';


export const getOrgSettings = async () => {
  const res = await Axios.get('/OrgSettings/');
  return res.data;
};

export const createOrgSettings = async (platformCharge: number) => {
  return Axios.post('/OrgSettings/', { platformCharge });
};

export const updateOrgSettings = async (id: string, platformCharge: number) => {
  return Axios.put(`/OrgSettings/${id}/`, { platformCharge });
};

export const deleteOrgSettings = async (id: string) => {
  return Axios.delete(`/orgSettings/${id}/`);
};
